import Vue from 'vue'
import axios from 'axios'
import {parse, isAfter, addDays} from 'date-fns'

import * as TYPE from '../util/types'

import { deepCopy } from '~/store/util/util'

const state = () => ({
  eventsLoaded: false,
  events: [],
  currentEvent: {},
  event_tags: [],
  filters: {
    date: null,
    min_price: 10,
    max_price: 40,
    category: null,
    distance: null
  },
  event_search_location: null,
})

const mutations = {
  [TYPE.SET_EVENTS_LOADED]: (state, payload) => {
    Vue.set(state, 'eventsLoaded', payload)
  },
  [TYPE.SET_EVENT_SEARCH_LOCATION]: (state, payload) => {
    Vue.set(state, 'event_search_location', payload)
  },
  [TYPE.SET_ALL_EVENTS]: (state, payload) => {
    Vue.set(state, 'events', payload)
  },
  [TYPE.SET_CURRENT_EVENT]: (state, payload) => {
    state.currentEvent = payload
  },
  [TYPE.SET_EVENT_PROP]: (state, payload) => {
    // let index = state.events.indexOf(state.events.find((obj) => {
    //   return obj.uuid === payload.uuid
    // }))
    Vue.set(state.currentEvent, payload.prop, payload.value)
  },
  [TYPE.SET_EVENT_TAGS]: (state, payload) => {
    Vue.set(state, 'event_tags', payload)
  },
  [TYPE.SET_EVENT_FILTER]: (state, payload) => {
    Vue.set(state.filters, payload.prop, payload.value)
  },
  [TYPE.ADD_EVENT]: (state, payload) => {
    state.events.push(payload)
  }
}

const actions = {
  // API CALLS
  favoriteEvent({ commit, rootState, getters }, payload) {
    let like = getters.user.liked_events.includes(payload.pk)
    let tempLiked = deepCopy(getters.user.liked_events)
    if (like) {
      let tempIndex = tempLiked.indexOf(payload.pk)
      tempLiked.splice(tempIndex, 1)
    } else {
      tempLiked.push(payload.pk)
    }
    commit(TYPE.SET_USER_PROP, {
      prop: 'liked_events',
      value: tempLiked
    })
    axios.post(
      '/api/v1/event/favorite/',
      {
        event_slug: payload.slug,
        like: !like,
      },
      {
        headers: { Accept: 'application/json' }
      }
    ).then(response => {
      let data = JSON.parse(response.data)
      // commit(TYPE.SET_USER_PROP, {
      // 	prop: 'liked_events',
      // 	value: data.liked_events
      // })
    })
    .catch(error => {
      console.error(error)
    })
  },
  fetchEventPrivate({ commit, state, getters }, payload) {
    return axios
      .get(
        '/api/v1/event-private/' + payload.event + '/user/' + payload.user + '/'
      )
      .then(response => {
        let eventIndex = state.events.indexOf(getters.getEvent(payload.event))
        let events = deepCopy(state.events)
        events.splice(eventIndex, 1, response.data)
        commit(TYPE.SET_ALL_EVENTS, events)
        return response
      })
      .catch(error => {
        console.error(error)
        return error
      })
  },
  serverRemoveImage({ commit }, pk) {
    axios
      .delete('/api/v1/image-upload/' + pk + '/')
      .then(response => {
        return response
      })
      .catch(error => {
        console.error(error)
      })
  },
  setEventProp({ commit }, payload) {
    commit(TYPE.SET_EVENT_PROP, payload)
  },
  setEventTags({ commit }, payload) {
    commit(TYPE.SET_EVENT_TAGS, payload)
  },
  postEvent({ commit }, payload) {
    return axios({
      method: 'post',
      url: '/api/v1/event/',
      data: payload
    })
      .then(result => {
        commit(TYPE.ADD_EVENT, payload);
        return result
      })
      .catch(error => {
        console.error(error)
      })
  },
  fetchAllEvents({ commit }) {
    axios
      .get('/api/v1/event/?format=json')
      .then(result => {
        commit(TYPE.SET_ALL_EVENTS, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  fetchNearbyEvents({ commit }, payload) {
    return axios
      .get(
        '/api/v1/nearbyevents/?format=json&location=' +
          payload.location +
          '&radius=' +
          payload.radius
      )
      .then(result => {
        commit(TYPE.SET_ALL_EVENTS, result.data)
        return result
      })
      .catch(error => {
        console.error(error)
      })
  },
  setEventSearchLocation: ({ commit }, payload) => {
    commit(TYPE.SET_EVENT_SEARCH_LOCATION, payload)
  },
  setEventFilter: ({ commit }, payload) => {
    commit(TYPE.SET_EVENT_FILTER, {
      prop: payload['prop'],
      value: payload['value']
    })
  },
  clearEventFilters: ({ state, commit }, payload) => {
    for (var i = 0; i < payload.length; i++) {
      commit(TYPE.SET_EVENT_FILTER, { prop: payload[i], value: null })
    }
  },
  eventRSVP: ({ state, commit }, payload) => {
    let data = JSON.parse(JSON.stringify(state.currentEvent))
    data.attendees.push(payload['user_pk'])
    commit(TYPE.SET_EVENT_PROP, {
      // uuid: state.events[i].uuid,
      prop: 'attendees',
      value: data.attendees
    })
    axios
      .put('/api/v1/event/' + payload['pk'] + '/', data)
      .catch(error => {
        console.error(error)
      })
  },
  setAllEvents: ({ commit }, payload) => {
    commit(TYPE.SET_ALL_EVENTS, payload)
  },
  addEvent: ({ commit }, payload) => {
    commit(TYPE.ADD_EVENT, payload)
  },
  setCurrentEvent: ({ commit }, payload) => {
    commit(TYPE.SET_CURRENT_EVENT, payload)
  },
  setEventsLoaded: ({commit}, payload) => {
    commit(TYPE.SET_EVENTS_LOADED, payload)
  }
}

const getters = {
  getEventsLoaded: state => state.eventsLoaded,
  getEventSearchLocation: state => {
    return state.event_search_location
  },
  getFeaturedEvents: (state, getters) => getters.getAllEvents.slice(0, 5),
  getFilteredEvents: (state, getters) => {
    var filtered = getters.getAllEvents.slice(0)
    if (!getters.userIsAuthenticated) {
      return []
    }
    if (state.filters.date !== null) {
      for (var i = filtered.length - 1; i >= 0; i--) {
        if (state.filters.date !== state.events[i].date) {
          filtered.splice(i, 1)
        }
      }
    }
    
    // if (filtered.length > 0) {
    //   if (filtered[0].hasOwnProperty('location')) {
    //     return filtered.slice(0).sort((a, b) => {
    //       let distanceA = getters.getLocationDistance(a.location.pk)
    //       let distanceB = getters.getLocationDistance(b.location.pk)
    //       return new Date(a.date) - new Date(b.date) || distanceA - distanceB
    //     })
    //   } else {
    //     return []
    //   }
    // } else {
    //   return filtered
    // }
    return filtered
  },
  getNonDateFilteredEvents: (state, getters) => {
    var filtered = state.events.slice(0)
    if (state.filters.min_price !== null) {
      for (var i = filtered.length - 1; i >= 0; i--) {
        if (filtered[i].min_price < state.filters.min_price) {
          filtered.splice(i, 1)
        }
      }
    }
    if (state.filters.max_price !== null) {
      for (i = filtered.length - 1; i >= 0; i--) {
        if (filtered[i].max_price > state.filters.max_price) {
          filtered.splice(i, 1)
        }
      }
    }
    if (state.filters.category !== null) {
      for (i = filtered.length - 1; i >= 0; i--) {
        if (filtered[i].category !== state.filters.category) {
          filtered.splice(i, 1)
        }
      }
    }
    if (!getters.userIsAuthenticated) return []
    return filtered.slice(0).sort((a, b) => {
      let distanceA = getters.getLocationDistance(a.location.pk)
      let distanceB = getters.getLocationDistance(b.location.pk)
      return new Date(a.date) - new Date(b.date) || distanceA - distanceB
    })
  },
  getCurrentEvent: (state) => state.currentEvent,
  getEvent: (state, getters) => eventID => {
    return getters.getAllEvents.find(event => {
      return event.pk === parseInt(eventID)
    })
  },
  getEventBySlug: (state, getters) => eventSlug => {
    return getters.getAllEvents.find(event => {
      return event.slug === eventSlug
    })
  },
  getEventByUuid: (state, getters) => eventUuid => {
    return getters.getAllEvents.find(event => {
      return event.uuid === eventUuid
    })
  },
  getAllEvents: (state, getters) => {
    if (!getters.userIsAuthenticated) return []
    let events = state.events.slice(0)
    return events
  },
  getMyEvents: (state, getters) => {
    if (!getters.userIsAuthenticated) return []
    return state.events
      .filter(e => {
        if (e.host) {
          return e.host.user.pk === getters.user.pk
        } else {
          return false
        }
      })
      .slice(0)
      .sort((a, b) => {
        return new Date(a.date) - new Date(b.date)
      })
  },
  getEventTags: state => {
    return state.event_tags
  },
  getEventFilters: state => {
    return state.filters
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
